import React from 'react';
import { Outlet } from 'react-router-dom';
import { IUser } from '../../../interfaces/User.interface';

import Tabs from '../tabs/Tabs';
import './Layout.scss';

interface ILayoutProps {
  currentUser: IUser;
  userDepots: string[];
  handleEditCurrentUserDepot: (depot: string) => void;
}

const Layout = ({
  currentUser,
  userDepots,
  handleEditCurrentUserDepot,
}: ILayoutProps): React.JSX.Element => {
  return (
    <div className="App-container">
      <Tabs
        currentUser={currentUser}
        userDepots={userDepots}
        handleEditCurrentUserDepot={handleEditCurrentUserDepot}
      />
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
